import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';

type SortOrderControlsProps = {
  canMoveUp: boolean;
  canMoveDown: boolean;
  onMoveUp?: () => void;
  onMoveDown?: () => void;
  disabled?: boolean;
};

export function SortOrderControls({
  canMoveUp,
  canMoveDown,
  onMoveUp,
  onMoveDown,
  disabled = false,
}: SortOrderControlsProps) {
  return (
    <div className="flex flex-col items-center gap-0.5">
      <button
        type="button"
        title="Mover para cima"
        aria-label="Mover para cima"
        disabled={disabled || !canMoveUp}
        onClick={onMoveUp}
        className="inline-flex items-center justify-center rounded p-0.5 text-secondary-500 transition-colors hover:bg-primary-50 hover:text-primary-600 disabled:cursor-default disabled:opacity-0"
      >
        <ChevronUpIcon className="h-4 w-4" aria-hidden="true" />
      </button>
      <button
        type="button"
        title="Mover para baixo"
        aria-label="Mover para baixo"
        disabled={disabled || !canMoveDown}
        onClick={onMoveDown}
        className="inline-flex items-center justify-center rounded p-0.5 text-secondary-500 transition-colors hover:bg-primary-50 hover:text-primary-600 disabled:cursor-default disabled:opacity-0"
      >
        <ChevronDownIcon className="h-4 w-4" aria-hidden="true" />
      </button>
    </div>
  );
}
